module.exports = __webpack_public_path__ + "static/media/splash.6639fe25.svg";